import { ConnectionPointPortData } from "./connectionPointPortData";
import * as styles from "./blockNodeData.module.scss";
export class BlockNodeData {
    get uniqueId() {
        return this.data.uniqueId;
    }
    get name() {
        return this.data.name;
    }
    getClassName() {
        return this.data.getClassName();
    }
    get isInput() {
        return this.data.isInput;
    }
    get inputs() {
        return this._inputs;
    }
    get outputs() {
        return this._outputs;
    }
    get comments() {
        return this.data.comments;
    }
    set comments(value) {
        this.data.comments = value;
    }
    get executionTime() {
        return -1; // Not applicable for particle blocks
    }
    getPortByName(name) {
        for (const input of this.inputs) {
            if (input.internalName === name) {
                return input;
            }
        }
        for (const output of this.outputs) {
            if (output.internalName === name) {
                return output;
            }
        }
        return null;
    }
    isConnectedToOutput() {
        const block = this.data;
        return block.isDebug || block.isAnAncestorOfType("SystemBlock");
    }
    dispose() {
        this.data.dispose();
        this.data.onBuildObservable.remove(this._onBuildObserver);
        this._onInputChangeObserver?.remove();
    }
    prepareHeaderIcon(iconDiv, img) {
        if (this.data.getClassName() === "ElbowBlock") {
            iconDiv.classList.add(styles.hidden);
            return;
        }
        iconDiv.classList.add(styles.hidden);
    }
    get invisibleEndpoints() {
        if (this.data.isTeleportIn) {
            const teleportIn = this.data;
            return teleportIn.endpoints;
        }
        return null;
    }
    constructor(data, nodeContainer) {
        this.data = data;
        this._inputs = [];
        this._outputs = [];
        this._onBuildObserver = null;
        this._onInputChangeObserver = null;
        if (data.inputs) {
            for (const input of this.data.inputs) {
                this._inputs.push(new ConnectionPointPortData(input, nodeContainer));
            }
        }
        if (data.outputs) {
            for (const output of this.data.outputs) {
                this._outputs.push(new ConnectionPointPortData(output, nodeContainer));
            }
        }
        this._onBuildObserver = data.onBuildObservable.add(() => {
            if (this.refreshCallback) {
                this.refreshCallback();
            }
        });
        this._onInputChangeObserver = data.onInputChangedObservable.add((input) => {
            for (let i = 0; i < this._inputs.length; i++) {
                if (this._inputs[i].data === input) {
                    // It's a remove
                    this._inputs.splice(i, 1);
                    if (this.onInputRemoved) {
                        this.onInputRemoved(i);
                    }
                    return;
                }
            }
            this._inputs.push(new ConnectionPointPortData(input, nodeContainer));
            if (this.onInputCountChanged) {
                this.onInputCountChanged();
            }
        });
    }
}
//# sourceMappingURL=blockNodeData.js.map